import { ViewModel, View, ObservableArray, ViewModelMessage } from "binder"
import moment from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { DragDropPossibilityChecker, DropAppliedViewModelMessage, Enum, IEnumTranslator, PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { SendPackageDetailViewModel } from "../sendPackageDetail/sendPackageDetail-viewModel";
import { SendCartableFormView } from "./sendCartableForm-view"
import { RegisterForServerNotification, UnregisterForServerNotification } from "src/server/serverNotification";
import { SendToLocalNotificationMessage } from "src/server/localNotification";

export class SendCartableFormViewModel extends WindowViewModel {
    public getTitle(): string {
        return "کارتابل ارسال کالا";
    }
    private _serverNotificationHandler;
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.sendables = ObservableArray.create<Sendable>();
        this.sendPackages = ObservableArray.create<SendPackage>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.GetAllSendPackages(filteringInformation), 15);
        this.refresh();
        this.startRefreshSendables();

        this._serverNotificationHandler = (command, parameter) => this.printSendableWithDelay(command, parameter);
        let msg = new RegisterForServerNotification("Print_Sendable", this._serverNotificationHandler);
        this.handleMessage(msg);
    }

    GetDefaultView(): View<ViewModel> {
        return new SendCartableFormView();
    }
    public getTypeId(): string {
        return "VM-539CB141-3C2C-4837-823E-91696CCE4640"
    }

    private _refreshTimer;
    public set sendables(v: ObservableArray<Sendable>) { this._sendables = v; } public get sendables(): ObservableArray<Sendable> { return this._sendables; } private _sendables: ObservableArray<Sendable>;
    public set sendPackageStateEnumProvider(v: SendPackageStateEnumProvider) { this._sendPackageStateEnumProvider = v; } public get sendPackageStateEnumProvider(): SendPackageStateEnumProvider { return this._sendPackageStateEnumProvider; } private _sendPackageStateEnumProvider: SendPackageStateEnumProvider;
    public set sendPackages(v: ObservableArray<SendPackage>) { this._sendPackages = v; } public get sendPackages(): ObservableArray<SendPackage> { return this._sendPackages; } private _sendPackages: ObservableArray<SendPackage>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set isLoadingSendable(v: boolean) { this._isLoadingSendable = v; } public get isLoadingSendable(): boolean { return this._isLoadingSendable; } private _isLoadingSendable: boolean;
    public set selectAll(v: boolean) {
        this._selectAll = v;
        if (v)
            this.sendables.forEach(x => x.isSelected = true);
        else
            this.sendables.forEach(x => x.isSelected = false);
    }
    public get selectAll(): boolean { return this._selectAll; } private _selectAll: boolean;

    async refresh() {
        try {
            await Promise.all([this.loader.refresh(), this.getSendables()]);
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }

    startRefreshSendables() {
        this._refreshTimer = setTimeout(() => {
            this.getSendables(),
                this.startRefreshSendables();
        }, 3 * 60 * 1000)
    }

    requestClose(): boolean {
        let msg = new UnregisterForServerNotification("Print_Sendable", this._serverNotificationHandler);
        this.handleMessage(msg);
        return true;
    }

    async createPackage() {
        try {
            this.isLoading = true;
            this.isLoadingSendable = true;
            let confirmation = '';
            confirmation = await this.messageBoxWarningYesNo('یک بسته با کالاهای انتخاب شده ساخته شود؟', 'ایجاد بسته');
            if (confirmation == 'no') {
                return;
            }
            var selectedIds = this.sendables.filter(x => x.isSelected).map(q => {
                return { SendableId: q.sendableId }
            });
            let result = await ServerConnection.callServer('Complex/WarehouseServices/CreateSendPackage', {
                SendableIds: selectedIds
            });
            await this.messageBoxConfirmSuccess('بسته های کالا با موفقیت ثبت شد.', 'عملیات موفق');
            this.refresh();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات', 'خطا');
        } finally {
            this.isLoading = false;
            this.isLoadingSendable = false;
        }
    }

    async addItemToSendPackage(sendable: Sendable[], sendPackage: SendPackage) {
        try {
            this.isLoading = true;
            this.isLoadingSendable = true;
            let confirmation = '';
            confirmation = await this.messageBoxWarningYesNo('کالا به بسته اضافه شود؟', 'افزودن به بسته');
            if (confirmation == 'no') {
                return;
            }
            let result = await ServerConnection.callServer('Complex/WarehouseServices/AddItemToSendPackage', {
                SendableId: sendable.map(x => x.sendableId),
                SendPackageId: sendPackage.sendPackageId
            });
            await this.messageBoxConfirmSuccess('کالا با موفقیت به بسته اضافه شد.', 'عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات', 'خطا');
        } finally {
            await this.refresh();
            this.isLoading = false;
            this.isLoadingSendable = false;
        }
    }

    async cancelSelected() {
        try {
            this.isLoadingSendable = true;
            let confirmation = '';
            confirmation = await this.messageBoxWarningYesNo('آیا درخواست ها لغو شود؟', 'لغو درخواست ها');
            if (confirmation == 'no') {
                return;
            }
            var selectedIds = this.sendables.filter(x => x.isSelected).map(q => {
                return { SendableId: q.sendableId }
            });
            let result = await ServerConnection.callServer('Complex/WarehouseServices/CancelBalanceTuningRequest', {
                SendableIds: selectedIds,
            });
            await this.messageBoxConfirmSuccess('درخواست ها با موفقیت لغو شدند.', 'عملیات موفق');
            this.refresh();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات', 'خطا');
        } finally {
            this.isLoadingSendable = false;
        }
    }

    async GetAllSendPackages(filteringInformation: any) {
        try {
            if (filteringInformation.OrderInfo.length == 0) {
                let sort = {
                    fieldName: 'createdTime',
                    order: 'DESC',
                    type: 'date'
                };
                filteringInformation.OrderInfo = [sort];
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/WarehouseServices/GetAllSendPackages',
                {
                    FilteringInformation: filteringInformation
                });
            this.sendPackages.update(...result.SendPackages.map((q, i) => {
                let r = new SendPackage(this);
                r.rowNumber = i + 1;
                r.sendPackageId = q.SendPackageId;
                r.creationTime = moment.utc(q.CreatedTime);
                r.comment = q.Comment;
                r.orderNumber = q.OrderNumber;
                r.sendNumber = q.SendNumber;
                r.sendPackageState = q.State;
                r.canCancel = q.CanCancel;
                r.toWarehouseId = q.ToWarehouseId;
                r.toWarehouseName = q.ToWarehouseName + '(' + q.ReceiptAmount + ')';
                r.fromWarehouseId = q.FromWarehouseId;
                r.fromWarehouseName = q.FromWarehouseName + '(' + q.OrderAmount + ')';
                r.amount = q.Amount;
                r.isEdited = false;
                r.orderAmount = q.OrderAmount;
                r.receiptAmount = q.ReceiptAmount;
                r.isFromMainWarehouse = q.IsFromMainWarehouse;
                return r;
            }))
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async getSendables() {
        try {
            this.isLoadingSendable = true;
            let result = await ServerConnection.callServer('Complex/WarehouseServices/GetAllUnsentSendables',
                {
                });
            this.sendables.update(...result.Sendables.map((q, i) => {
                let r = new Sendable(this);
                r.rowNumber = i + 1;
                r.sendableId = q.SendableId;
                r.creationTime = moment.utc(q.CreatedDate);
                r.creatorName = q.CreatorName;
                r.invoiceNumber = q.InvoiceNumber;
                r.hasInvoice = stringIsNullOrEmpty(q.InvoiceNumber) ? false : true;
                r.isInvoiceFromMainWarehouse = q.IsFromMainWarehouse == true && stringIsNullOrEmpty(q.InvoiceNumber);
                r.isInvoiceNotFromMainWarehouse = q.IsFromMainWarehouse == false && stringIsNullOrEmpty(q.InvoiceNumber);
                r.toWarehouseId = q.ToWarehouseId;
                r.toWarehouseName = q.ToWarehouseName;
                r.fromWarehouseId = q.FromWarehouseId;
                r.fromWarehouseName = q.FromWarehouseName;
                r.isSelected = false;
                r.isPrinted = q.IsPrinted;
                r.products = q.Products.map(p => {
                    let f = new SendableLineItem(this);
                    r.balance += p.Balance;
                    f.balance = p.Balance;
                    f.measuredProductId = p.MeasuredProductId;
                    f.availableBalance = p.AccessibleBalance;
                    f.stockBalance = p.StockBalance;
                    f.productCarModel = p.ProductCarModel;
                    f.productCode = p.ProductCode;
                    f.productName = p.ProductName;
                    f.warehouseLocation = p.WarehouseLocation;
                    f.productInfo = f.productCode + '(' + f.stockBalance + ',' + f.availableBalance + ')';
                    return f;
                });
                r.productInfo = r.products.map(q => {
                    return q.productInfo
                }).join('\n');
                r.warehouseLocation = r.products.map(q => {
                    return q.warehouseLocation
                }).join(' \n ');
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoadingSendable = false;
        }
    }

    printSendableWithDelay(command: string, parameter: { SendableId: string }) {
        let delayTimeInSecond = 1.5;
        if (command == "Print_Sendable") {
            setTimeout(() => { this.sendPrintRequestForSendableItem(parameter.SendableId) }, delayTimeInSecond * 1000);
        }
    }

    sendPrintRequestForSendableItem(sendableId: string) {
        let reletedSendableIndex = this.sendables.findIndex(s => s.sendableId == sendableId);
        if (reletedSendableIndex != -1) {
            let sendable = this.sendables[reletedSendableIndex];
            new PrintSendableItemAction(this).Print(sendable);
        }
    }

    printSelectedSendables(){
        this.sendables.filter(s => s.isSelected).forEach(s => s.print());
    }
}

export class Sendable extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: SendCartableFormViewModel) {
        super(parent);
        this._typedParent = parent;
        this.balance = 0;
        this.products = ObservableArray.create<SendableLineItem>();
    }

    private _typedParent: SendCartableFormViewModel;

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set sendableId(v: string) { this._sendableId = v; } public get sendableId(): string { return this._sendableId; } private _sendableId: string;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId; } private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName; } private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId; } private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName; } private _toWarehouseName: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set creatorName(v: string) { this._creatorName = v; } public get creatorName(): string { return this._creatorName; } private _creatorName: string;
    public set invoiceNumber(v: string) { this._invoiceNumber = v; } public get invoiceNumber(): string { return this._invoiceNumber; } private _invoiceNumber: string;
    public set products(v: ObservableArray<SendableLineItem>) { this._products = v; } public get products(): ObservableArray<SendableLineItem> { return this._products; } private _products: ObservableArray<SendableLineItem>;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;
    public set productInfo(v: string) { this._productInfo = v; } public get productInfo(): string { return this._productInfo; } private _productInfo: string;
    public set warehouseLocation(v: string) { this._warehouseLocation = v; } public get warehouseLocation(): string { return this._warehouseLocation; } private _warehouseLocation: string;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected; } private _isSelected: boolean;
    public set isPrinted(v: boolean) { this._isPrinted = v; } public get isPrinted(): boolean { return this._isPrinted; } private _isPrinted: boolean;
    public set isInvoiceFromMainWarehouse(v: boolean) { this._isInvoiceFromMainWarehouse = v; } public get isInvoiceFromMainWarehouse(): boolean { return this._isInvoiceFromMainWarehouse;} private _isInvoiceFromMainWarehouse: boolean;
    public set hasInvoice(v: boolean) { this._hasInvoice = v; } public get hasInvoice(): boolean { return this._hasInvoice; } private _hasInvoice: boolean;
    public set isInvoiceNotFromMainWarehouse(v: boolean) { this._isInvoiceNotFromMainWarehouse = v; } public get isInvoiceNotFromMainWarehouse(): boolean { return this._isInvoiceNotFromMainWarehouse;} private _isInvoiceNotFromMainWarehouse: boolean;
    
    print(){
        this._typedParent.sendPrintRequestForSendableItem(this.sendableId);
    }
}

export class SendPackage extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: SendCartableFormViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: SendCartableFormViewModel;

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set sendPackageId(v: string) { this._sendPackageId = v; } public get sendPackageId(): string { return this._sendPackageId; } private _sendPackageId: string;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId; } private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName; } private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId; } private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName; } private _toWarehouseName: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set orderNumber(v: string) { this._orderNumber = v; } public get orderNumber(): string { return this._orderNumber; } private _orderNumber: string;
    public set sendNumber(v: string) { this._sendNumber = v; } public get sendNumber(): string { return this._sendNumber; } private _sendNumber: string;
    public set packageNumber(v: number) { this._packageNumber = v; } public get packageNumber(): number { return this._packageNumber; } private _packageNumber: number;
    public set sendPackageState(v: number) { this._sendPackageState = v; } public get sendPackageState(): number { return this._sendPackageState; } private _sendPackageState: number;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set orderAmount(v: number) { this._orderAmount = v; } public get orderAmount(): number { return this._orderAmount; } private _orderAmount: number;
    public set receiptAmount(v: number) { this._receiptAmount = v; } public get receiptAmount(): number { return this._receiptAmount; } private _receiptAmount: number;
    public set comment(v: string) {
        this._comment = v;
        this.isEdited = true;
    } public get comment(): string { return this._comment; } private _comment: string;
    public set receiptNumber(v: number) { this._receiptNumber = v; } public get receiptNumber(): number { return this._receiptNumber; } private _receiptNumber: number;
    public set isEdited(v: boolean) { this._isEdited = v; } public get isEdited(): boolean { return this._isEdited; } private _isEdited: boolean;
    public set canCancel(v: boolean) { this._canCancel = v; } public get canCancel(): boolean { return this._canCancel; } private _canCancel: boolean;
    public set isFromMainWarehouse(v: boolean) { this._isFromMainWarehouse = v; } public get isFromMainWarehouse(): boolean { return this._isFromMainWarehouse;} private _isFromMainWarehouse: boolean;
    

    async saveComment() {
        try {
            this._typedParent.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/SetSendPackageComment', {
                SendPackageId: this.sendPackageId,
                Comment: this.comment
            });
            if (result.IsSuccessful) {
                await this.messageBoxConfirmSuccess('توضیحات با موفقیت ثبت شدند.', 'عملیات موفق');
                this.isEdited = false;
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this._typedParent.isLoading = false;
        }
    }

    async remove() {
        try {
            this._typedParent.isLoading = true;
            let confirmation = '';
            confirmation = await this.messageBoxWarningYesNo('آیا بسته لغو شود؟', 'لغو بسته');
            if (confirmation == 'no') {
                return;
            }
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/CancelSendPackage', {
                SendPackageId: this.sendPackageId,
            });
            if (result.IsSuccessful == false) {
                throw "new Error";
            }
            if (result.Removed == true) {
                await this.messageBoxConfirmSuccess('بسته با موفقیت لغو شدند.', 'عملیات موفق');
                this._typedParent.refresh();
            } else {
                await this.messageBoxConfirmWarning('امکان حذف این بسته وجود ندارد.', "خطا")
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex, "خطا")
        } finally {
            this._typedParent.isLoading = false;
        }
    }

    async showDetail() {
        let sendPackageDetail = new SendPackageDetailViewModel(this._typedParent, this.sendPackageId);
        let result = await this._typedParent.showPopup(sendPackageDetail);
        this._typedParent.refresh();
    }

    override handleMessage(message: ViewModelMessage) {
        if (message instanceof DragDropPossibilityChecker) {
            if (message.dragged instanceof Sendable && message.droppedTo instanceof SendPackage && message.droppedTo.sendPackageState == 0) {
                return message.createAllowanceResponse(`اضافه شدن به دسته با نام ${message.droppedTo.comment} و شماره ${message.droppedTo.orderNumber}`);
            } else {
                return message.createRejectResponse();
            }
        } else if (message instanceof DropAppliedViewModelMessage && message.dragged instanceof Sendable && message.droppedTo instanceof SendPackage) {
            var addingSendables = this._typedParent.sendables.filter(x => x.isSelected == true);
            if (addingSendables.includes(message.dragged) == false) {
                addingSendables.push(message.dragged);
            }
            this._typedParent.addItemToSendPackage(addingSendables, message.droppedTo);
            return null;
        } else {
            return super.handleMessage(message);
        }
    }
}

export class SendableLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: SendCartableFormViewModel) {
        super(parent);
        this.typedParent = parent;
    }

    private typedParent: SendCartableFormViewModel;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId; } private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel; } private _productCarModel: string;
    public set stockBalance(v: number) { this._stockBalance = v; } public get stockBalance(): number { return this._stockBalance; } private _stockBalance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance; } private _availableBalance: number;
    public set productInfo(v: string) { this._productInfo = v; } public get productInfo(): string { return this._productInfo; } private _productInfo: string;
    public set warehouseLocation(v: string) { this._warehouseLocation = v; } public get warehouseLocation(): string { return this._warehouseLocation; } private _warehouseLocation: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;

}

export class SendPackageStateEnumProvider extends Enum implements IEnumTranslator {
    constructor() {
        super();
        this.values = [0, 1, 2, 3];
        this.translator = this;
        this.converter = new TranslatorConverter();
    }
    private converter: TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateSendPackageState(value);
    }
}

export class PrintSendableItemAction {
    constructor(parent: ViewModel) {
        this._parent = parent;
    }

    private _parent;

    public async Print(sendable: Sendable): Promise<void> {

        let data = <any>{
            FromWarehouse: sendable.toWarehouseName,
            ToWarehouse: sendable.fromWarehouseName,
            RequestDate: sendable.creationTime,
            Type: sendable.hasInvoice ? "فاکتور" : "درخواست",
            SendableLineItems: sendable.products.map((product, index) => {
                return {
                    RowNumber: index + 1,
                    Name: product.productName,
                    Code: product.productCode,
                    Location: product.warehouseLocation,
                    Amount: product.balance
                }
            })
        };
        var message = new SendToLocalNotificationMessage("requestPrint", {
            Form: "SendableItem",
            Data: data
        });
        return this._parent.handleMessage(message);
    }
}